export enum EActionTypes {
  GET_ESTIMATION_REQUEST = 'estimation/request',
  GET_ESTIMATION_SUCCESS = 'estimation/success',
  GET_ESTIMATION_FAILURE = 'estimation/failure',
  GET_ESTIMATION_CLEAR = 'estimation/clear',
}
